import { Component } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ErrorComponent, SelectComponent } from '@group24ag/flowkit';

@Component({
  imports: [ErrorComponent, FormsModule, ReactiveFormsModule, SelectComponent],
  selector: 'app-ui-multiselect',
  template: `
    <div>
      <h1 class="heading-title">Multiselect</h1>
      <div class="flex flex-col gap-10">
        <ng-template #selectedTemplateRef let-item="item">
          {{ item }}
        </ng-template>
        <ng-template #optionTemplateRef let-option="option">
          {{ option }}
        </ng-template>
        <flk-select
          [isMultiselect]="true"
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control1"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-select
          [isMultiselect]="true"
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control2"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96" />
        <flk-select
          [isMultiselect]="true"
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control3"
          [options]="stringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96">
          <flk-error>Selection is required</flk-error>
        </flk-select>
        <flk-select
          [isMultiselect]="true"
          [selectedTemplate]="selectedTemplateRef"
          [optionTemplate]="optionTemplateRef"
          [formControl]="control4"
          [options]="lotsOfStringOptions"
          [placeholder]="placeholder"
          [label]="label"
          class="w-96">
          <flk-error>Selection is required</flk-error>
        </flk-select>
      </div>
    </div>
  `,
})
export class UIMultiSelectComponent {
  placeholder = 'Select your names';
  label = 'Name';

  stringOptions = ['Foo', 'Bar'];
  lotsOfStringOptions = [
    'Foo',
    'Bar',
    'Baz',
    'Qux',
    'Quux',
    'Corge',
    'Grault',
    'Garply',
    'Waldo',
    'Fred',
    'Plugh',
    'Xyzzy',
    'Thud',
  ];

  control1 = new FormControl([]);
  control2 = new FormControl({ value: ['Foo', 'Bar'], disabled: true });
  control3 = new FormControl([], [Validators.required]);
  control4 = new FormControl([]);
}
